// extracted by mini-css-extract-plugin
export default {"warning-box":"Warning_warning-box__Blpvy"};